import { formatDateTime } from '../../shared/utility/dateFormatter';
import {
  RECORD_CATEGORY_KEYS,
  VIEW_PERMISSION,
} from '../constants/personRelatedRecordsTabConstants';

export const renderDate = (value) => (value ? formatDateTime(value) : '');

export const renderDateValue = (params) => renderDate(params.value);

export const joinOffenses = (value) =>
  Array.isArray(value) ? value.map((offense) => offense?.Description).join(', ') : value || '';

export const renderOffensesValue = (params) => joinOffenses(params.value);

export const getViewPermission = (category, permissions) => {
  if (category === RECORD_CATEGORY_KEYS.RMS_INCIDENTS) {
    const p = permissions?.rms?.Incidents;
    if (p?.Edit) return VIEW_PERMISSION.EDIT;
    if (p?.Read) return VIEW_PERMISSION.READ;
    return null;
  }

  if (category === RECORD_CATEGORY_KEYS.WARRANTS) {
    const p = permissions?.globals?.Warrants;
    if (p?.Edit) return VIEW_PERMISSION.EDIT;
    if (p?.Read) return VIEW_PERMISSION.READ;
    return null;
  }

  if (category === RECORD_CATEGORY_KEYS.CITATIONS) {
    const p = permissions?.globals?.Citations;
    if (p?.Edit) return VIEW_PERMISSION.EDIT;
    if (p?.Read) return VIEW_PERMISSION.READ;
    return null;
  }

  if (category === RECORD_CATEGORY_KEYS.CAD_INCIDENTS) {
    const p = permissions?.cad?.Events;
    return p?.Edit || p?.Read ? VIEW_PERMISSION.READ : null;
  }

  return null;
};
